import {ACTION_APP_LOADING_START, ACTION_APP_LOADING_END} from '../actions';
import {CLEAR_STATE} from "../constants";

const loadingInitialState = 0;

export const loading = (state = loadingInitialState, action)=>{

    switch ( action.type ){
        case ACTION_APP_LOADING_START:
            return state + 1 ;

        case ACTION_APP_LOADING_END:
            return  state > 1? state-1 : 0;

        case CLEAR_STATE:
            return loadingInitialState;

        default:
            return state;
    }

};

const defaultState = {};
export const loadingIds = ( state=defaultState, action) =>{

    switch( action.type ){

        case ACTION_APP_LOADING_START:
            if( action.payload && action.payload.id ) return  {...state, [action.payload.id]: true};
            else return state;
        case ACTION_APP_LOADING_END:
            if( action.payload && action.payload.id ) return  {...state, [action.payload.id]: false};
            else return state;
        case CLEAR_STATE:
            return defaultState;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/App/reducers/loading.js